import { BaseService } from '../../../shared/Services/BaseService';
import { authenticationService } from '../../../shared/Services/authenticationService';
import { HttpClient } from '@angular/common/http';

import { Injectable } from '@angular/core';
import { environment } from '../../../../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class RateCategoryService extends BaseService {
  constructor(http: HttpClient, authenticationSerives: authenticationService) {
    const baseUrl = environment.apiUrl + 'RateCategory';

    super(http, authenticationSerives, baseUrl);
  }
}
